import { render } from "./TrashCanSvg.vue?vue&type=template&id=7d4fef3b&scoped=true"
import script from "./TrashCanSvg.vue?vue&type=script&lang=ts"
export * from "./TrashCanSvg.vue?vue&type=script&lang=ts"

import "./TrashCanSvg.vue?vue&type=style&index=0&id=7d4fef3b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7d4fef3b"

export default script